import axios from 'axios'
import moment from 'moment-timezone'

export default () => {
    return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "X-Client-Timezone": moment.tz.guess()
        }
    })
}